import { Injectable } from '@angular/core';
import { IModalOptions } from '../../common/modals/modal-options.interface';
import { Observable, of } from 'rxjs';
import { EcaModalOptions } from '../../shared/models/yesno-modal-options.class';
import { EcaDynamicModalService } from "../../shared/services/eca-dynamic-modal-service";
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { IEcaDialogRef } from '../../shared/models/eca-dialog-ref.interface';
import { ICompanyInfo } from "../../message-models/company-info.interface";
import { CompanySettingsEmailModalComponent } from "../../../app/company/components/company-settings-email-modal/company-settings-email-modal.component";

@Injectable({
  providedIn: 'root'
})

export class CompanySettingsModalService {
  companySettingsModalRef: IEcaDialogRef;
  constructor(private ecaDynamicModalService: EcaDynamicModalService) { }

  openCompanySettingsEmailModal(headerText?: string, options?: IModalOptions): Observable<IEcaDialogRef> {
    if (this.companySettingsModalRef) {
      this.companySettingsModalRef.dynamicDialogRef.close();
    }
    if (options === undefined) {
      options = new EcaModalOptions();
      options.modalClasses += ' modal-eca-success';
    }

    let config = {
      styleClass: 'modal-xl ' + options.modalClasses,
      baseZIndex: 2000,
      showHeader: false,
      header: headerText,
      data: {
        headerText: headerText,
      }
    } as DynamicDialogConfig;

    this.companySettingsModalRef = this.ecaDynamicModalService.openDialog(CompanySettingsEmailModalComponent, config);
    return of(this.companySettingsModalRef);
  }
}
